// extracted by mini-css-extract-plugin
export default {"list":"LessonList_list__DJ2Gb"};